module.exports = __webpack_public_path__ + "img/asia-ever.1e512a90.svg";